import { useState } from "react";
import { toast } from "sonner";
import { CircleDashed, Loader2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { siteUrl, track } from "@/lib/api";
import { makeStatusCard } from "@/lib/statusCard";
import { usePriceText } from "@/components/dm/ui";

export const StatusShare = ({ p, className = "" }) => {
  const { t, L, hubOf, areaOf, cat } = useApp();
  const price = usePriceText()(p);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const url = `${siteUrl()}/post/${p.id}?via=status`;
      const place = [p.area_id && L(areaOf(p.area_id)), L(hubOf(p.hub_id))].filter(Boolean).join(" · ");
      const blob = await makeStatusCard(p, url, { label: t(p.type === "request" ? "request" : "listing").toUpperCase(), help: t("can_you_help"), place, price, scan: t("status_scan"), catName: L(cat(p.category_id)) || "" });
      const file = new File([blob], `diaspomark-${p.id.slice(0, 8)}.png`, { type: "image/png" });
      track("share_click", { post_id: p.id, meta: { channel: "status_card" } });
      if (navigator.canShare?.({ files: [file] })) {
        try { await navigator.share({ files: [file], text: `${p.title} — ${url}` }); } catch { /* user closed the sheet */ }
      } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 2000);
        toast.success(t("status_saved"));
      }
    } catch { toast.error(t("error")); }
    setBusy(false);
  };
  return (
    <button data-testid="status-share" onClick={go} disabled={busy}
      className={`press min-h-[48px] px-5 rounded-full bg-[#ECF3EF] text-[#133E2F] font-extrabold inline-flex items-center justify-center gap-2 disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <CircleDashed className="w-5 h-5" />}{t("status_share")}
    </button>
  );
};
